export const wpAjaxFetch = async (action, params = {}, parseJson = true) => {
  try {
    const response = await fetch(tdea_ajax.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: action,
        nonce: tdea_ajax.nonce,
        ...params,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error en la petición: ${errorText}`);
    }

    if (parseJson) {
      const data = await response.json();
      console.log("Respuesta JSON:", data);
      return data;
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error AJAX:", error);
    throw error;
  }
};
